// @flow

import * as React from 'react';

import ToggleButtonGroupAction from './ToggleButtonGroupAction';

import type { CommonActionProps } from './types.actions';

type Props = {
  onClick: (filters: any) => void,
  filters: any,
  repCode: string,
};

const FILTER_TYPE = 'Rep';

export const REP_OPTIONS = [
  {
    value: 'AcctR',
    text: 'Rep Accounts',
  },
  {
    value: 'InvR',
    text: 'Rep Invoices',
  },
];

class RepFilterAction extends React.Component<Props & CommonActionProps> {
  static defaultProps = {
    size: 'xsmall',
    disabled: false,
    filterType: FILTER_TYPE,
  };

  constructor(props) {
    super(props);

    this.state = {
      // to match in UI default button selection on initial mount,
      // caused by the GridOData auto select after connection group panel to grid
      selectedFilter:  REP_OPTIONS[0].value,
    };

    this.options = this.mapOptionsToRepCode(REP_OPTIONS);
  }

  oldDerivedStateFromProps(nextProps: Props) {
    if (nextProps.saveStatus === 'reset') {
     return this.setState({
        selectedFilter: null,
      });
    }

    return null;
  }

  componentDidMount() {
    this.oldDerivedStateFromProps(this.props, this.state);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props !== prevProps) {
      this.oldDerivedStateFromProps(this.props, this.state);
    }
  }

  handleChange = value => {
    const option = this.options.find(
      currentFilter => currentFilter.value === value,
    );

    this.setState({
      selectedFilter: value,
    });

    this.props.onClick(
      this.props.filterType,
      option ? option.filter : undefined,
    );
  };

  getSelectedFilter = () => {
    const filterValue =
      this.props.filters && this.props.filters[this.props.filterType];
    return filterValue && Object.keys(filterValue)[0];
  };

  mapOptionsToRepCode = options => {
    return options.map(opt => ({
      ...opt,
      filter: {
        [opt.value]: {
          eq: this.props.repCode,
        },
      },
    }));
  };

  render() {
    const { size, disabled } = this.props;

    return (
      <ToggleButtonGroupAction
        onChange={this.handleChange}
        bsSize={size}
        disabled={disabled}
        type="radio"
        value={this.state.selectedFilter}
        options={this.options}
        name="dateFilter"
      />
    );
  }
}

export default RepFilterAction;
